module.exports = __webpack_public_path__ + "static/college-savings-plans-hero-desktop.693d27ff.webp";